import { useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { nextPredictionStep } from 'utils/crafting';
import useEffectOnce from './useEffectOnce';
import { clearCraftBlocks, setCraftBlocks } from 'store/crafting';
import { getEligibles } from 'services/craftPredictionService';
import { useSoundPath } from './useSoundPath';
import useProfile from './useProfile';

const useCraftPrediction = () => {
  const { search } = useLocation();
  const { token } = useProfile();
  const craftBlocks = useSelector((state) => state.crafting.prediction);
  const {refreshTrigger} = useSelector((state) => state.cards);
  const dispatch = useDispatch();
  const [activeBlock, setActiveBlock] = useState('');
  const [isEligiblesLoading, setIsEligiblesLoading] = useState(false);
  const [eligibles, setEligibles] = useState([]);
  const [queryParams, setQueryParams] = useState(new URLSearchParams());
  const [selectCards, setSelectCards] = useState([]);
  const [filters, setFilters] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [offsetCount, setOffsetCount] = useState(0)
  const resetCards = () => setSelectCards([]);
  const playSound = useSoundPath();

  const nextStep = () => {
    nextPredictionStep(activeBlock, craftBlocks, setActiveBlock);
    setOffsetCount(0);
  }


  const parseQueryStringToObject = (queryString) => {
    const params = new URLSearchParams(queryString);
    return Object.fromEntries(params.entries());
  };


  useEffectOnce(() => {
    const params = new URLSearchParams(search);

    if (params.has('activeBlock')) {
      try {
        const blockValue = params.get('activeBlock');
        setActiveBlock(blockValue);
        const decodedSearch = decodeURIComponent(search.slice(1));
        const queryParamsObject = parseQueryStringToObject(decodedSearch);
        const {activeBlock, activeTag, cardRarity, type} = queryParamsObject
        const card = JSON.parse(queryParamsObject.card);
        dispatch(setCraftBlocks({activeBlock, activeTag, cardRarity, type, card}));
        nextPredictionStep(activeBlock, craftBlocks, setActiveBlock)
        getEligibles(craftBlocks, activeBlock, setIsEligiblesLoading, setEligibles);
      } catch (error) {
        console.log(error);
      }

    } else {
      dispatch(clearCraftBlocks('prediction'))
      setActiveBlock('Identity');
    }
  });

  return {
    search, token, craftBlocks, refreshTrigger, dispatch, activeBlock, setActiveBlock,
    isEligiblesLoading, setIsEligiblesLoading, eligibles, setEligibles, queryParams, setQueryParams,
    selectCards, setSelectCards, filters, setFilters, activeFilters, setActiveFilters,
    paginationData, setPaginationData, offsetCount, setOffsetCount, resetCards, nextStep, playSound
  }
}

export default useCraftPrediction;
